import { Outlet } from 'react-router-dom'
;
import Firstgrade_k1_subjects from './firstgrade_k1_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Firstgrade_k1 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Firstgrade_k1_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Firstgrade_k1;